import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams, Xiaohongshu } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface SearchXiaohongshuTopicListParams extends ActiomCommonParams {
    searchValue: string;
}

export type PublishAction = CommonAction<SearchXiaohongshuTopicListParams, Xiaohongshu.Topic[]>;

export const searchXiaohongshuTopicList: PublishAction = async (_task, params) => {
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://creator.xiaohongshu.com",
        origin: "https://creator.xiaohongshu.com",
    };

    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
    const http = new Http(...args);
    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: [] };

    const topicData = {
        keyword: params.searchValue,
        suggest_topic_request: {
            title: "",
            desc: `#${params.searchValue}`,
        },
        page: {
            page_size: 20,
            page: 1,
        },
    };

    const fatchTopic = "/web_api/sns/v1/search/topic";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});

    const fatchTopicXsHeader = xsEncrypt.signHeadersPost(fatchTopic, recordCookie, "xhs-pc-web", topicData);

    const result = await http.api<{ code: number; msg: string; data: { topic_info_dtos: Xiaohongshu.Topic[] } }>(
        {
            method: "post",
            url: "https://edith.xiaohongshu.com/web_api/sns/v1/search/topic",
            data: topicData,
            headers: fatchTopicXsHeader,
            defaultErrorMsg: "话题搜索异常，请稍后重试。",
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = result.code === 0;
    const message = `获取话题${isSuccess ? "成功" : `失败，原因：${result.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? result.data.topic_info_dtos : [];

    return response(isSuccess ? 0 : 414, message, data);
};
